module.exports = __webpack_public_path__ + "img/主数据服务.e193ab24.svg";